import moment from "moment";
import {AppDataGirdNGBSComponent} from '@shared/components/data-grid';
import {IFrmFilterCommon, IFrmFilterGroup, IResponseApi} from '@core/models';
import {isArray} from '@shared/utils/app.utils';
import {
  API_COMMON_DATE,
  API_COMMON_DATE_MONTH_YEAR,
  DISPLAY_DATE_FORMAT,
  DISPLAY_SHORT_MONTHYEAR_MOMENT
} from '@shared/constants';
import {HEADER_STATUS_CODE} from '@core/constants';

export function trackActiveFiltersDG(appDg: AppDataGirdNGBSComponent) {
  if (!appDg.filterForm) return;

  const values = appDg.filterValuesTrackEmpty;

  appDg.activeFilters = [];

  appDg.filterFields.map(f => {
    const _vals = [];
    let required = f.required ?? false;
    if (f.groupInputs) {
      if (!f.typeBasic) {
        f.groupInputs.childs.map(fCl => {
          const val = _handlerTrackActive(fCl, values, appDg);
          if (val) {
            _vals.push(val.value);
          }
          if (fCl.required) {
            required = true;
          }
        })
      }
    } else if (f.dateRange && !f.typeBasic) {
      const fromDate = _handlerTrackActive(f.dateRange.fromDate, values, appDg);
      const toDate = _handlerTrackActive(f.dateRange.toDate, values, appDg);
      if (fromDate) {
        _vals.push(fromDate.value);
      }
      if (toDate) {
        _vals.push(toDate.value);
      }
      if (f.dateRange.fromDate.required || f.dateRange.toDate.required) {
        required = true;
      }
    } else {
      const val = _handlerTrackActive(f, values, appDg);
      if (val) {
        _vals.push(val.value);
      }
    }

    if (_vals && _vals.length) {
      let strJoin = ' - ';
      if (f.groupInputs && typeof f.groupInputs.operator != 'undefined') {
        strJoin = f.groupInputs.operator;
      }
      appDg.activeFilters.push({
        key: f.key,
        label: f.label,
        value: _vals.join(strJoin),
        required: required,
        disableLabelTranslate: f.disableLabelTranslate ? f.disableLabelTranslate : false
        // isJoinArr: isJoinArr
      });
    }
  })
}

function _handlerTrackActive(f: IFrmFilterCommon | IFrmFilterGroup, values: any, appDg: AppDataGirdNGBSComponent) {
  // Does not deal with basic types
  if (f.typeBasic) {
    return null;
  }

  if (f && values?.[f.key] && f.type != 'hidden') {
    const currentVal = values?.[f.key];
    const txtArr: any[] = [];
    switch (f.type) {
      case 'select':
      case 'select2':
      case 'selectPages':
        if (f.options) {
          f.options.map(o => {
            const cVal = o.value.toString();
            let isValid = cVal == currentVal;
            if (isArray(currentVal)) {
              isValid = currentVal.find((v: string | number) => {
                if (v.toString() == cVal.toString()) {
                  return true;
                }
                return false
              });
            }
            if (isValid) txtArr.push(o.label)
          });
        }
        break;
      case 'checkbox':
        // Sửa lỗi: Checkbox không được tích (false/'false') thì không được tạo badge
        if (currentVal != 0 && currentVal != '' && currentVal != false && currentVal != 'false' && f.label) {
          txtArr.push(appDg.appService.translate(f.label));
        }
        break;
      case 'datePicker':
      case 'tmpDateSingle':
        if (currentVal != 0 && currentVal != '') {
          // Nếu là số thì hiểu là Unix Timestamp (giây), nếu là chuỗi thì parse theo format chuẩn
          const mDate = (typeof currentVal === 'number') ? moment.unix(currentVal) : moment(currentVal, API_COMMON_DATE);
          const strDate = mDate.isValid() ? mDate.format(DISPLAY_DATE_FORMAT) : '';
          if (strDate) {
            txtArr.push(strDate);
          }
        }
        break;
      case 'monthPicker':
        if (currentVal != 0 && currentVal != '') {
          const mDate = (typeof currentVal === 'number') ? moment.unix(currentVal) : moment(currentVal, API_COMMON_DATE_MONTH_YEAR);
          const strDate = mDate.isValid() ? mDate.format(DISPLAY_SHORT_MONTHYEAR_MOMENT) : '';
          if (strDate) {
            txtArr.push(strDate);
          }
        }
        break;
      default:
        if (f.suggest && f.suggest.paramName) {
          let valName = appDg.navService.getParam(f.suggest.paramName) ?? '';
          const ctrlField = appDg.filterForm.get(f.suggest.paramName);
          if (ctrlField && ctrlField.value) {
            valName = ctrlField.value
          }
          txtArr.push(valName ? valName : currentVal);
        } else {
          txtArr.push(currentVal);
        }

        break;
    }

    const isValid = isArray(txtArr) ? txtArr.length : txtArr;
    if (isValid) {
      let txtValue: any = '';
      let isJoinArr = false;
      if (isArray(txtArr)) {
        if (typeof txtArr === 'object' && Object.keys(txtArr).length > 1) {
          txtValue = `Đã chọn ${Object.keys(txtArr).length}`;
          isJoinArr = true;
        } else if (txtArr && txtArr.length > 1) {
          txtValue = `Đã chọn ${txtArr.length}`;
          isJoinArr = true;
        } else {
          txtValue = txtArr.join('');
        }
      } else {
        txtValue = txtArr;
      }

      return {
        value: txtValue,
        required: f.required ?? false,
        isJoinArr: isJoinArr
      };
    }
  }
  return null;
}


/**
 * Hàm kiểm tra xem response trả về có phải các dạng lỗi code header thì cần trả thông báo lỗi mặc định
 * */
export function filterResErrorMessages(res: IResponseApi<any>): string | string[] {
  if (res.statusCode == HEADER_STATUS_CODE.INTERNAL_SERVER_ERROR) {
    return 'common.notify.tryAgainError';
  }

  return res.messages;
}
